import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import en_messages from './en_messages';
import PressPalletIcon from "./PressPalletIcon";
import PeopleIcon from "../people/PeopleIcon";
import SupervisorIcon from "../SupervisorIcon";
import PressJobsIcon from "../pressjobs/PressJobsIcon";
import BuildPalletUI from "./operatorviewbuild/BuildPalletUI";
import {ReprintPalletUI} from "./operatorviewreprint/ReprintPalletUI";
import ManualPalletUI from "./operatorviewmanual/ManualPalletUI";
import AddIcon from '@material-ui/icons/Add';

const menuItems = [];
menuItems.push({parentMenu: 'operator', name: 'operatorPalletBuilder', route: 'ppbbuildpallet', parentMenuIcon: (<PeopleIcon/>), icon: (<PressPalletIcon/>)});
menuItems.push({parentMenu: 'operator', name: 'operatorPalletReprint', route: 'ppboperatorreprint', parentMenuIcon: (<PeopleIcon/>), icon: (<PressJobsIcon/>)});
menuItems.push({parentMenu: 'operator', name: 'operatorManualPallet', route: 'ppboperatormanual', parentMenuIcon: (<PeopleIcon/>), icon: (<AddIcon/>)});

const customRoutes = [];

// noLayout for a non layout route
customRoutes.push(<Route exact path="/ppbbuildpallet" component={BuildPalletUI} />);
customRoutes.push(<Route exact path="/ppboperatorreprint" component={ReprintPalletUI} />);
customRoutes.push(<Route exact path="/ppboperatormanual" component={ManualPalletUI} />);

export const messages = {
    en: en_messages
}

const PressPalletBuilderResources = ({
    RESOURCE: 'presspalletbuilder',
    TITLE: '',
    LIST: null,
    CREATE: null,
    // EDIT: PressPalletEdit,
    SHOW: null,
    ICON: (<PressPalletIcon/>),
    messages: messages,
    disabled: false,
    menuHidden: true,
    parentMenu: 'supervisor',
    parentMenuIcon: (<SupervisorIcon />),
    customMenuItems: menuItems,
    customRoutes: customRoutes,
    menuAuth: 'supervisor'
});


export default PressPalletBuilderResources;


